{
    "_meta": {
        "Name": {
            "type": "Text",
            "label": "Full Name",
            "required": true
        },
        "Email": {
            "type": "Email",
            "label": "Email Address",
            "required": true
        },
        "FirstName": {
            "type": "Text",
            "label": "First Name",
            "required": true
        },
        "LastName": {
            "type": "Text",
            "label": "Last Name",
            "required": true
        },
        "password": {
            "type": "Password",
            "label": "Password",
            "required": true
        },
        "AvatarUrl": {
            "type": "Text",
            "label": "Avatar Url"
        },
        "organisation_c": {
            "type": "Text",
            "label": "Organisation"
        }
    },
    "records": [
        {
            "Id": "a41c9d27-5e8f-4b06-9c3a-d7f218e64b90",
            "userId": "a41c9d27-5e8f-4b06-9c3a-d7f218e64b90",
            "companyId": "5c1d8e46-3b9a-4f27-8d64-0a2e7b91c5d3",
            "Name": "Demo Facilitator",
            "FirstName": "Demo",
            "LastName": "Facilitator",
            "Email": "facilitator@demo.app",
            "password": "demo1234",
            "AvatarUrl": null,
            "organisation_c": "AICX Programme Office",
            "IsOwner": true,
            "accounts": [
                {
                    "userId": "a41c9d27-5e8f-4b06-9c3a-d7f218e64b90",
                    "companyId": "5c1d8e46-3b9a-4f27-8d64-0a2e7b91c5d3",
                    "companyName": "AICX Cohort",
                    "companyUserId": 1,
                    "isOwner": true,
                    "profile": {
                        "id": 1,
                        "name": "Facilitator_c"
                    },
                    "companyOwner": {
                        "name": "Demo Facilitator",
                        "avatarUrl": null,
                        "email": "facilitator@demo.app"
                    }
                }
            ]
        },
        {
            "Id": "7b2e5f10-3c84-4d9a-b1e6-92a0c7d35f48",
            "userId": "7b2e5f10-3c84-4d9a-b1e6-92a0c7d35f48",
            "companyId": "5c1d8e46-3b9a-4f27-8d64-0a2e7b91c5d3",
            "Name": "Demo Learner",
            "FirstName": "Demo",
            "LastName": "Learner",
            "Email": "learner@demo.app",
            "password": "demo1234",
            "AvatarUrl": null,
            "organisation_c": "NorthStar Bank",
            "IsOwner": false,
            "accounts": [
                {
                    "userId": "7b2e5f10-3c84-4d9a-b1e6-92a0c7d35f48",
                    "companyId": "5c1d8e46-3b9a-4f27-8d64-0a2e7b91c5d3",
                    "companyName": "AICX Cohort",
                    "companyUserId": 2,
                    "isOwner": false,
                    "profile": {
                        "id": 2,
                        "name": "Learner_c"
                    },
                    "companyOwner": {
                        "name": "Demo Facilitator",
                        "avatarUrl": null,
                        "email": "facilitator@demo.app"
                    }
                }
            ]
        },
        {
            "Id": "e83d6a42-91bf-4c57-a2d8-5f10b6c94e23",
            "userId": "e83d6a42-91bf-4c57-a2d8-5f10b6c94e23",
            "companyId": "5c1d8e46-3b9a-4f27-8d64-0a2e7b91c5d3",
            "Name": "Priya Raman",
            "FirstName": "Priya",
            "LastName": "Raman",
            "Email": "priya@demo.app",
            "password": "demo1234",
            "AvatarUrl": null,
            "organisation_c": "Meridian Insurance",
            "IsOwner": false,
            "accounts": [
                {
                    "userId": "e83d6a42-91bf-4c57-a2d8-5f10b6c94e23",
                    "companyId": "5c1d8e46-3b9a-4f27-8d64-0a2e7b91c5d3",
                    "companyName": "AICX Cohort",
                    "companyUserId": 3,
                    "isOwner": false,
                    "profile": {
                        "id": 2,
                        "name": "Learner_c"
                    },
                    "companyOwner": {
                        "name": "Demo Facilitator",
                        "avatarUrl": null,
                        "email": "facilitator@demo.app"
                    }
                }
            ]
        },
        {
            "Id": "c15f9b73-2d06-4e8a-8f41-7a93d0e2b6c5",
            "userId": "c15f9b73-2d06-4e8a-8f41-7a93d0e2b6c5",
            "companyId": "5c1d8e46-3b9a-4f27-8d64-0a2e7b91c5d3",
            "Name": "Fresh Learner",
            "FirstName": "Fresh",
            "LastName": "Learner",
            "Email": "fresh@demo.app",
            "password": "demo1234",
            "AvatarUrl": null,
            "organisation_c": "",
            "IsOwner": false,
            "accounts": [
                {
                    "userId": "c15f9b73-2d06-4e8a-8f41-7a93d0e2b6c5",
                    "companyId": "5c1d8e46-3b9a-4f27-8d64-0a2e7b91c5d3",
                    "companyName": "AICX Cohort",
                    "companyUserId": 4,
                    "isOwner": false,
                    "profile": {
                        "id": 2,
                        "name": "Learner_c"
                    },
                    "companyOwner": {
                        "name": "Demo Facilitator",
                        "avatarUrl": null,
                        "email": "facilitator@demo.app"
                    }
                }
            ]
        }
    ]
}
